import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DeleteFlow from './DeleteFlow';
import { retrieveFlows } from '../services/database';
import { Edit2, Trash2 } from 'lucide-react';

const Flows = ({ projectId }) => {
  const navigate = useNavigate();
  const [flows, setFlows] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // <-- Added loading state
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedFlowId, setSelectedFlowId] = useState(null);

  useEffect(() => {
    const fetchFlows = async () => {
      try {
        const flowsData = await retrieveFlows(projectId);
        // Transform each flow so we have flowId available.
        const updatedFlows = flowsData.map((flowDoc) => ({
          ...flowDoc,
          flowId: flowDoc._id // rename _id to flowId
        }));
        setFlows(updatedFlows);
      } catch (error) {
        console.error('Error retrieving flows:', error);
      } finally {
        setIsLoading(false); // <-- Set loading to false after data is fetched
      }
    };

    fetchFlows();
  }, [projectId]);

  const handleNewFlow = () => {
    navigate('/create-flow', { state: { projectId } });
  };

  const handleFlowClick = (flowId) => {
    navigate('/view-flow', { state: { projectId, flowId } });
  };

  const handleDeleteClick = (flowId) => {
    setSelectedFlowId(flowId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedFlowId(null);
  };

  // Remove the deleted flow from the local list
  const deleteFlow = (flowId) => {
    setFlows((prev) => prev.filter((flow) => flow.flowId !== flowId));
  };

  const handleEditClick = (flowId) => {
    navigate('/edit-flow', { state: { projectId, flowId } });
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold">Flows</h2>
        <button
          onClick={handleNewFlow}
          className="text-white bg-black px-4 py-2 rounded-md hover:bg-gray-800 transition-colors duration-200"
        >
          + New
        </button>
      </div>
      <hr className="mb-4 border-gray-300" />

      {isLoading ? (
        <p>Loading flows...</p>  // <-- Show loading state
      ) : flows.length === 0 ? (
        <p>No flows created yet.</p>
      ) : (
        <ul>
          {flows.map((flow) => (
            <li
              key={flow.flowId}
              className="flex items-center justify-between border p-2 rounded-md mb-2 hover:border-black"
            >
              <button
                onClick={() => handleFlowClick(flow.flowId)}
                className="text-left flex-grow"
              >
                {flow.title.length > 30 ? `${flow.title.substring(0, 30)}...` : flow.title}
              </button>
              <button
                onClick={() => handleEditClick(flow.flowId)}
                className="ml-2 mr-2 text-gray-400 hover:text-gray-800"
              >
                <Edit2 size={20}/>
              </button>
              <button
                onClick={() => handleDeleteClick(flow.flowId)}
                className="ml-2 text-gray-400 hover:text-red-600"
              >
                <Trash2 size={20}/>
              </button>
            </li>
          ))}
        </ul>
      )}

      {showDeleteModal && (
        <DeleteFlow
          flowId={selectedFlowId}
          onClose={closeDeleteModal}
          onDelete={deleteFlow}
        />
      )}
    </div>
  );
};

export default Flows;
